export default {
  name: "Dragon Stout",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/logo-color.webp`,
  products: [
    {
      id: "stout",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/en/product-foward_stout.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/fr/product-foward_stout.webp`,
      },
      name: {
        en: "Stout",
        fr: "Stout",
      },
      description: {
        en: "Known as Jamaica's best-kept secret, Dragon Stout is a perfect blend of Pilsen & roasted malt, suger, hops, water and caramel colouring. Enjoyed since 1920, Dragon Stout continues to hold its own in the market as a Jamaican favourite.",
        fr: "Connue comme le secret le mieux gardé de la Jamaïque, la bière Dragon Stout est un mélange parfait de malt Pilsen et de malt torréfié, de sucre, de houblon, d'eau et de colorant caramel. Appréciée depuis 1920, la Dragon Stout continue de s'imposer sur le marché comme la boisson préférée des Jamaïcains.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/en/information_render_bottle_284ml_dragonstout.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/fr/information_render_bottle_284ml_dragonstout.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/en/information_nft_bottle_284ml_dragonstout.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/dragonstout/fr/information_nft_bottle_284ml_dragonstout_fr.webp`,
          },
          name: {
            en: "Bottle 284ml",
            fr: "Bouteille 284ml",
          },
        },
      ],
    },
  ],
};
